import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47c0d2c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "m-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "Partnership Pavilion")
], -1))
const _hoisted_2 = { class: "d-flex flex-column align-items-center justify-content-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center fw-bold" }, " Official webshop of MDC - Memphis Depay Clothing. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fst-italic text-center" }, " \"It became very clear in an early stage that this logo had to do something with my trademark: fingers in both ears when I score. Blind and deaf to the world. It strengthens my focus, and makes me stronger. I want my brand to convey that.\" ", -1))
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-link fa-2x" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-instagram fa-2x" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-twitter fa-2x" }, null, -1))
const _hoisted_10 = { class: "d-flex flex-column align-items-center justify-content-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " They say \"Red Bull gives you wiiings\", and for me this is absolutely true. Red Bull brings creativity and energy to everything they do and these shared values and their support are invaluable in helping me bring my vision and dreams to reality. ", -1))
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-link fa-2x" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-instagram fa-2x" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-twitter fa-2x" }, null, -1))
const _hoisted_17 = { class: "d-flex flex-column align-items-center justify-content-center" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Sports have the power to transform and empower us. As one of the world's leading sports brands, it's only natural that we want to stand on the same playing field as the fastest athletes on the planet. To achieve that, the PUMA brand is based on the very values that make an excellent athlete. ", -1))
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-link fa-2x" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-instagram fa-2x" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-twitter fa-2x" }, null, -1))
const _hoisted_24 = { class: "d-flex flex-column align-items-center justify-content-center" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" At ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("rightclickable.com")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" we are focused on creating and managing bespoke turnkey brand-aligned NFT solutions, which have a distinctive personality, utility and community. RightClickable enables brands, personalities and public figures to harness the power of NFTs and play a significant role in the future of DeFi, P2E, gaming, wearables, and authentication as users migrate towards Web3. ")
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-link fa-2x" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-instagram fa-2x" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-twitter fa-2x" }, null, -1))

import PageFooter from '@/components/PageFooter.vue';
import BackButton from '@/components/buttons/BackButton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PartnersPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, null, {
    default: _withCtx(() => [
      _createVNode(BackButton),
      _hoisted_1,
      _createElementVNode("main", null, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("img", {
            src: require('@/assets/mdc-logo.png'),
            alt: "MDC"
          }, null, 8, _hoisted_3),
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_b_link, {
              class: "me-3",
              href: "https://memphisdepay.com",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_b_link, {
              class: "m-3",
              href: "https://instagram.com/memphisdepayclothing",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_b_link, {
              class: "ms-3",
              href: "https://twitter.com/official_MDC",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_10, [
          _createElementVNode("img", {
            id: "redbull",
            class: "img img-thumbnail",
            src: require('@/assets/red-bull-memphis.png'),
            alt: "Red Bull"
          }, null, 8, _hoisted_11),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_b_link, {
              class: "me-3",
              href: "https://redbull.com",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }),
            _createVNode(_component_b_link, {
              class: "m-3",
              href: "https://instagram.com/redbull",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }),
            _createVNode(_component_b_link, {
              class: "ms-3",
              href: "https://twitter.com/redbull",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_17, [
          _createElementVNode("img", {
            src: require('@/assets/puma-logo.png'),
            alt: "Puma"
          }, null, 8, _hoisted_18),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_b_link, {
              class: "me-3",
              href: "https://puma.com",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }),
            _createVNode(_component_b_link, {
              class: "m-3",
              href: "https://instagram.com/puma",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            }),
            _createVNode(_component_b_link, {
              class: "ms-3",
              href: "https://twitter.com/puma",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_24, [
          _createElementVNode("img", {
            src: require('@/assets/right-clickable-logo.png'),
            alt: "rightclickable"
          }, null, 8, _hoisted_25),
          _createElementVNode("p", _hoisted_26, [
            _hoisted_27,
            _createVNode(_component_b_link, {
              href: "https://rightclickable.com",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            }),
            _hoisted_29
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_b_link, {
              class: "me-3",
              href: "https://rightclickable.com",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }),
            _createVNode(_component_b_link, {
              class: "m-3",
              href: "https://instagram.com/rightclickable",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            }),
            _createVNode(_component_b_link, {
              class: "ms-3",
              href: "https://twitter.com/rightclickable_",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _hoisted_33
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(PageFooter)
    ]),
    _: 1
  }))
}
}

})